(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.boundUpdateHeaderBounds = this.updateHeaderBounds.bind(this);

      this.setHeaderHeight();

      this._mqlHeaderHeight = window.matchMedia('(max-width: 1089px)');
      this._onMqlHeaderHeightChange = this.setHeaderHeight.bind(this);
      this._mqlHeaderHeight.addEventListener('change', this._onMqlHeaderHeightChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler, { passive: true });
      if (this._mqlHeaderHeight && this._onMqlHeaderHeightChange) {
        this._mqlHeaderHeight.removeEventListener('change', this._onMqlHeaderHeightChange);
      }
      if (this._boundsListenersActive) {
        window.removeEventListener('resize', this.boundUpdateHeaderBounds);
        document.removeEventListener('shopify:section:load', this.boundUpdateHeaderBounds);
      }
    }

    updateHeaderBounds() {
      if (!this.header) return;
      const height = this.header.offsetHeight;
      const main = document.getElementById('MainContent');
      const scrollY = this.scrollTopNow();

      if (main) {
        let mainTop = main.getBoundingClientRect().top + scrollY;
        const body = document.body;
        const hasTransparentHeader =
          body &&
          (body.classList.contains('template-index') ||
            body.getAttribute('data-page-type') === 'index' ||
            body.getAttribute('data-transparent-header') === 'true');
        if (hasTransparentHeader) {
          const raw = getComputedStyle(document.documentElement).getPropertyValue('--zh-header-group-height').trim();
          const parsed = parseFloat(raw);
          if (Number.isFinite(parsed) && parsed > 0) mainTop = Math.max(mainTop, parsed);
        }
        const top = mainTop - height;
        const bottom = mainTop;
        if (Number.isFinite(top) && Number.isFinite(bottom) && bottom >= top) {
          this.headerBounds = {
            top,
            bottom,
            left: this.header.offsetLeft,
            width: this.header.offsetWidth,
            height,
          };
          return;
        }
      }

      let top = 0;
      let node = this.header;
      while (node) {
        top += node.offsetTop;
        node = node.offsetParent;
      }
      this.headerBounds = {
        top,
        bottom: top + height,
        left: this.header.offsetLeft,
        width: this.header.offsetWidth,
        height,
      };
    }

    createObserver() {
      this._boundsListenersActive = true;
      this.updateHeaderBounds();
      requestAnimationFrame(() => this.updateHeaderBounds());
      window.addEventListener('resize', this.boundUpdateHeaderBounds);
      document.addEventListener('shopify:section:load', this.boundUpdateHeaderBounds);
    }

    scrollTopNow() {
      const winTop = window.pageYOffset ?? window.scrollY ?? 0;
      if (winTop) return winTop;
      const se = document.scrollingElement || document.documentElement;
      return (se && se.scrollTop) || (document.body && document.body.scrollTop) || 0;
    }

    applyScrollUpReveal() {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    }

    onScroll() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = this.scrollTopNow();
        return;
      }

      this.updateHeaderBounds();

      const scrollTop = this.scrollTopNow();
      const prevScrollTop = this.currentScrollTop;

      if (typeof this.headerBounds.bottom !== 'number') {
        this.currentScrollTop = scrollTop;
        return;
      }

      const goingDown = scrollTop > prevScrollTop;
      const goingUp = scrollTop < prevScrollTop;
      const hidden = this.header.classList.contains('shopify-section-header-hidden');
      const revealFromHidePosition =
        hidden &&
        typeof this._scrollTopAtHide === 'number' &&
        scrollTop < this._scrollTopAtHide - 0.5;

      if (goingDown && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (hidden && (goingUp || revealFromHidePosition)) {
        this.applyScrollUpReveal();
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this._scrollTopAtHide = this.scrollTopNow();
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeight();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this._scrollTopAtHide = null;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      void this.header.offsetHeight;
      this.setHeaderHeight();
      requestAnimationFrame(() => this.setHeaderHeight());
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this._scrollTopAtHide = null;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setHeaderHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
